var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBeacons = function SvgBeacons(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65 0a9.65 9.65 0 0 1 5.466 17.604l-1.216-.765A8.35 8.35 0 0 0 9.65 1.3 8.35 8.35 0 0 0 1.3 9.65a8.35 8.35 0 0 0 4.1 7.19l-1.216.764A9.64 9.64 0 0 1 0 9.65 9.65 9.65 0 0 1 9.65 0zm0 3a6.65 6.65 0 0 1 2.573 12.784l-1.437-.905a5.351 5.351 0 1 0-2.271.001l-1.438.904A6.652 6.652 0 0 1 9.65 3zm0 3a3.65 3.65 0 1 1 0 7.3 3.65 3.65 0 0 1 0-7.3zm0 1.3a2.35 2.35 0 1 0 0 4.7 2.35 2.35 0 0 0 0-4.7z"
  })));
};

export default SvgBeacons;